import React from 'react';
import {
  Expand,
  Footprints,
  MapPinCheck,
  Monitor,
  MoonStar,
  PersonStanding,
  RotateCcw,
  Settings2,
  Shrink,
  Tag,
  X,
} from 'lucide-react';

const SIZE_OPTIONS = [
  { value: 'small', label: '小巧', icon: Shrink },
  { value: 'medium', label: '标准', icon: Monitor },
  { value: 'large', label: '宽阔', icon: Expand },
];

const SPEED_OPTIONS = [
  { value: 'relaxed', label: '从容' },
  { value: 'standard', label: '标准' },
  { value: 'fast', label: '轻快' },
];

function SegmentedControl({ value, options, onChange, label }) {
  return (
    <div className="pixel-town-settings__segments" role="group" aria-label={label} style={{ gridTemplateColumns: `repeat(${options.length}, minmax(0, 1fr))` }}>
      {options.map((option) => {
        const Icon = option.icon;
        const selected = option.value === value;
        return (
          <button
            type="button"
            key={option.value}
            className="pixel-town-settings__segment"
            aria-pressed={selected}
            onClick={() => onChange(option.value)}
          >
            {Icon && <Icon size={13} />}
            <span>{option.label}</span>
          </button>
        );
      })}
    </div>
  );
}

function ToggleRow({ icon, label, checked, onChange }) {
  const Icon = icon;
  return (
    <button
      type="button"
      className="pixel-town-settings__toggle-row"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
    >
      <span className="pixel-town-settings__toggle-label">
        <Icon size={14} />
        {label}
      </span>
      <span className="pixel-town-settings__switch" aria-hidden="true">
        <span />
      </span>
    </button>
  );
}

export default function TownSettingsPanel({
  preferences,
  onChange,
  onReset,
  onCustomizeAvatar,
  onClose,
}) {
  return (
    <section
      id="pixel-town-settings"
      className="pixel-town-settings"
      role="dialog"
      aria-modal="false"
      aria-label="小镇设置"
      data-pixel-town-ignore-keys="true"
    >
      <header className="pixel-town-settings__header">
        <div>
          <Settings2 size={15} />
          <strong>小镇设置</strong>
        </div>
        <button
          type="button"
          className="pixel-town-settings__close"
          onClick={onClose}
          aria-label="关闭小镇设置"
        >
          <X size={15} />
        </button>
      </header>

      <div className="pixel-town-settings__body">
        <section className="pixel-town-settings__section">
          <div className="pixel-town-settings__section-title">
            <Expand size={14} />
            <span>小镇大小</span>
          </div>
          <SegmentedControl
            label="小镇大小"
            value={preferences.townSize}
            options={SIZE_OPTIONS}
            onChange={(value) => onChange('townSize', value)}
          />
        </section>

        <section className="pixel-town-settings__section">
          <div className="pixel-town-settings__section-title">
            <Footprints size={14} />
            <span>行走速度</span>
          </div>
          <SegmentedControl
            label="行走速度"
            value={preferences.movementSpeed}
            options={SPEED_OPTIONS}
            onChange={(value) => onChange('movementSpeed', value)}
          />
        </section>

        <div className="pixel-town-settings__toggles">
          <ToggleRow
            icon={MoonStar}
            label="随时间变化氛围"
            checked={preferences.ambience}
            onChange={(value) => onChange('ambience', value)}
          />
          <ToggleRow
            icon={MapPinCheck}
            label="记住上次位置"
            checked={preferences.rememberPosition}
            onChange={(value) => onChange('rememberPosition', value)}
          />
          <ToggleRow
            icon={Tag}
            label="显示人物名字"
            checked={preferences.showNameTags}
            onChange={(value) => onChange('showNameTags', value)}
          />
        </div>
      </div>

      <footer className="pixel-town-settings__footer">
        <button
          type="button"
          className="pixel-town-settings__secondary-action"
          onClick={onReset}
          title="恢复默认设置"
        >
          <RotateCcw size={14} />
          恢复默认
        </button>
        {onCustomizeAvatar && (
          <button
            type="button"
            className="pixel-town-settings__primary-action"
            onClick={onCustomizeAvatar}
          >
            <PersonStanding size={14} />
            编辑形象
          </button>
        )}
      </footer>
    </section>
  );
}
